<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12ZM10.9562 10.5584C12.1025 9.98533 13.3931 11.0206 13.0823 12.2639L12.3733 15.0999L12.4148 15.0792C12.7852 14.894 13.2357 15.0441 13.421 15.4146C13.6062 15.7851 13.4561 16.2356 13.0856 16.4208L13.0441 16.4416C11.8979 17.0147 10.6072 15.9794 10.9181 14.7361L11.6271 11.9001L11.5856 11.9208C11.2151 12.1061 10.7646 11.9559 10.5793 11.5854C10.3941 11.2149 10.5443 10.7644 10.9148 10.5792L10.9562 10.5584ZM12 9C12.4142 9 12.75 8.66421 12.75 8.25C12.75 7.83579 12.4142 7.5 12 7.5C11.5858 7.5 11.25 7.83579 11.25 8.25C11.25 8.66421 11.5858 9 12 9Z"
        />
    </svg>
    <svg
        v-else
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM11 8.25C11 7.69772 11.4477 7.25 12 7.25H12.0075C12.5598 7.25 13.0075 7.69772 13.0075 8.25V8.2575C13.0075 8.80978 12.5598 9.2575 12.0075 9.2575H12C11.4477 9.2575 11 8.80978 11 8.2575V8.25ZM11.2818 12.2497C10.904 12.2615 10.5357 12.0575 10.3556 11.6972C10.1086 11.2032 10.3088 10.6026 10.8028 10.3556L10.8443 10.3348C12.1816 9.66619 13.6873 10.874 13.3246 12.3245L12.7182 14.7503C13.096 14.7385 13.4643 14.9425 13.6444 15.3028C13.8914 15.7967 13.6912 16.3974 13.1972 16.6444L13.1557 16.6652L13.1557 16.6652C11.8184 17.3338 10.3127 16.126 10.6754 14.6755L11.2818 12.2497Z"
        />
    </svg>
</template>
